// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Employeemodal.module.css */

.Employeemodal_modalOverlay__rgdrd {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 20px;
  box-sizing: border-box;
}

.Employeemodal_modalBox__PweZH {
  background: white;
  padding: 30px;
  border-radius: 12px;
  width: 520px;
  max-width: 100%;
  max-height: 90vh; /* ✅ Maximum height set */
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  overflow: hidden; /* ✅ Hide overflow from box */
}

.Employeemodal_modalBox__PweZH h2 {
  margin-bottom: 20px;
  font-size: 20px;
  font-weight: 600;
  color: #333;
  flex-shrink: 0; /* ✅ Prevent header from shrinking */
}

/* ✅ Scrollable form container */
.Employeemodal_modalBox__PweZH form {
  overflow-y: auto; /* ✅ Vertical scroll */
  overflow-x: hidden;
  flex: 1 1;
  padding-right: 5px; /* ✅ Space for scrollbar */
}

/* ✅ Custom scrollbar styling (optional) */
.Employeemodal_modalBox__PweZH form::-webkit-scrollbar {
  width: 6px;
}

.Employeemodal_modalBox__PweZH form::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.Employeemodal_modalBox__PweZH form::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 10px;
}

.Employeemodal_modalBox__PweZH form::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.Employeemodal_formGroup__D9q1H {
  margin-bottom: 15px;
}

.Employeemodal_formGroup__D9q1H label {
  display: block;
  font-weight: 500;
  margin-bottom: 5px;
  font-size: 14px;
  color: #444;
}

.Employeemodal_formGroup__D9q1H input,
.Employeemodal_formGroup__D9q1H select {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  box-sizing: border-box;
}

.Employeemodal_formGroup__D9q1H input:focus,
.Employeemodal_formGroup__D9q1H select:focus {
  outline: none;
  border-color: #4caf50;
  box-shadow: 0 0 0 2px rgba(76, 175, 80, 0.15);
}

.Employeemodal_formGroup__D9q1H input:disabled,
.Employeemodal_formGroup__D9q1H select:disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
}

.Employeemodal_twoColumnGrid__C8Awu {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
  width: 100%;
}

/* ✅ Modal Actions - Fixed at bottom */
.Employeemodal_modalActions__hxmMp {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
  padding-top: 15px;
  border-top: 1px solid #eee;
  flex-shrink: 0; /* ✅ Prevent actions from shrinking */
  background: white; /* ✅ Keep background white */
  position: sticky;
  bottom: 0;
  z-index: 10;
}

.Employeemodal_saveBtn__GkMbF {
  background: #4caf50;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background 0.3s ease;
  white-space: nowrap; /* ✅ Prevent button text from wrapping */
}

.Employeemodal_saveBtn__GkMbF:hover {
  background: #3d9b41;
}

.Employeemodal_saveBtn__GkMbF:active {
  transform: scale(0.98);
}

.Employeemodal_cancelBtn__kYn5H {
  background: #6c757d;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background 0.3s ease;
  white-space: nowrap; /* ✅ Prevent button text from wrapping */
}

.Employeemodal_cancelBtn__kYn5H:hover {
  background: #5a6268;
}

.Employeemodal_cancelBtn__kYn5H:active {
  transform: scale(0.98);
}

.Employeemodal_error__6nSxo {
  color: #dc3545;
  font-size: 12px;
  margin-top: 4px;
}

/* ✅ Responsive for very small screens */
@media screen and (max-width: 576px) {
  .Employeemodal_modalOverlay__rgdrd {
    padding: 10px;
    align-items: flex-start;
    padding-top: 20px;
  }

  .Employeemodal_modalBox__PweZH {
    padding: 20px;
    width: 100%;
    max-height: 95vh;
    border-radius: 8px;
  }

  .Employeemodal_modalBox__PweZH h2 {
    font-size: 18px;
    margin-bottom: 15px;
  }

  .Employeemodal_twoColumnGrid__C8Awu {
    grid-template-columns: 1fr; /* ✅ Single column on small screens */
    gap: 0;
  }

  .Employeemodal_formGroup__D9q1H {
    margin-bottom: 12px;
  }

  .Employeemodal_formGroup__D9q1H input,
  .Employeemodal_formGroup__D9q1H select {
    padding: 8px 10px;
    font-size: 13px;
  }

  .Employeemodal_modalActions__hxmMp {
    flex-direction: column-reverse; /* ✅ Stack buttons vertically */
    gap: 8px;
    padding-top: 12px;
    margin-top: 15px;
  }

  .Employeemodal_modalActions__hxmMp button {
    width: 100%; /* ✅ Full width buttons */
    padding: 12px;
    font-size: 14px;
  }

  .Employeemodal_saveBtn__GkMbF,
  .Employeemodal_cancelBtn__kYn5H {
    white-space: normal; /* ✅ Allow text wrap if needed */
  }
}

/* ✅ Tablet screens */
@media screen and (min-width: 577px) and (max-width: 768px) {
  .Employeemodal_modalBox__PweZH {
    width: 90%;
    max-height: 85vh;
    padding: 25px;
  }

  .Employeemodal_twoColumnGrid__C8Awu {
    gap: 12px;
  }
}

/* ✅ Landscape mode on mobile */
@media screen and (max-height: 600px) and (orientation: landscape) {
  .Employeemodal_modalOverlay__rgdrd {
    align-items: flex-start;
    padding-top: 10px;
  }

  .Employeemodal_modalBox__PweZH {
    max-height: 95vh;
    padding: 15px 20px;
  }

  .Employeemodal_modalBox__PweZH h2 {
    font-size: 16px;
    margin-bottom: 10px;
  }

  .Employeemodal_formGroup__D9q1H {
    margin-bottom: 8px;
  }

  .Employeemodal_formGroup__D9q1H input,
  .Employeemodal_formGroup__D9q1H select {
    padding: 6px 10px;
    font-size: 13px;
  }

  .Employeemodal_twoColumnGrid__C8Awu {
    gap: 10px;
  }

  .Employeemodal_modalActions__hxmMp {
    margin-top: 10px;
    padding-top: 10px;
  }

  .Employeemodal_modalActions__hxmMp button {
    padding: 8px 16px;
    font-size: 13px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Masters/Employee Master/EmployeeList/Employeemodal.module.css"],"names":[],"mappings":"AAAA,6BAA6B;;AAE7B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB,EAAE,yBAAyB;EAC3C,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,gBAAgB,EAAE,6BAA6B;AACjD;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,cAAc,EAAE,oCAAoC;AACtD;;AAEA,gCAAgC;AAChC;EACE,gBAAgB,EAAE,sBAAsB;EACxC,kBAAkB;EAClB,SAAO;EACP,kBAAkB,EAAE,0BAA0B;AAChD;;AAEA,0CAA0C;AAC1C;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;;EAEE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,WAAW;AACb;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,cAAc,EAAE,qCAAqC;EACrD,iBAAiB,EAAE,4BAA4B;EAC/C,gBAAgB;EAChB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB,EAAE,wCAAwC;AAC/D;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB,EAAE,wCAAwC;AAC/D;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA,wCAAwC;AACxC;EACE;IACE,aAAa;IACb,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,0BAA0B,EAAE,qCAAqC;IACjE,MAAM;EACR;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,8BAA8B,EAAE,+BAA+B;IAC/D,QAAQ;IACR,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,WAAW,EAAE,yBAAyB;IACtC,aAAa;IACb,eAAe;EACjB;;EAEA;;IAEE,mBAAmB,EAAE,gCAAgC;EACvD;AACF;;AAEA,qBAAqB;AACrB;EACE;IACE,UAAU;IACV,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,SAAS;EACX;AACF;;AAEA,+BAA+B;AAC/B;EACE;IACE,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF","sourcesContent":["/* Employeemodal.module.css */\n\n.modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.4);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  padding: 20px;\n  box-sizing: border-box;\n}\n\n.modalBox {\n  background: white;\n  padding: 30px;\n  border-radius: 12px;\n  width: 520px;\n  max-width: 100%;\n  max-height: 90vh; /* ✅ Maximum height set */\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden; /* ✅ Hide overflow from box */\n}\n\n.modalBox h2 {\n  margin-bottom: 20px;\n  font-size: 20px;\n  font-weight: 600;\n  color: #333;\n  flex-shrink: 0; /* ✅ Prevent header from shrinking */\n}\n\n/* ✅ Scrollable form container */\n.modalBox form {\n  overflow-y: auto; /* ✅ Vertical scroll */\n  overflow-x: hidden;\n  flex: 1;\n  padding-right: 5px; /* ✅ Space for scrollbar */\n}\n\n/* ✅ Custom scrollbar styling (optional) */\n.modalBox form::-webkit-scrollbar {\n  width: 6px;\n}\n\n.modalBox form::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 10px;\n}\n\n.modalBox form::-webkit-scrollbar-thumb {\n  background: #c1c1c1;\n  border-radius: 10px;\n}\n\n.modalBox form::-webkit-scrollbar-thumb:hover {\n  background: #a8a8a8;\n}\n\n.formGroup {\n  margin-bottom: 15px;\n}\n\n.formGroup label {\n  display: block;\n  font-weight: 500;\n  margin-bottom: 5px;\n  font-size: 14px;\n  color: #444;\n}\n\n.formGroup input,\n.formGroup select {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 14px;\n  box-sizing: border-box;\n}\n\n.formGroup input:focus,\n.formGroup select:focus {\n  outline: none;\n  border-color: #4caf50;\n  box-shadow: 0 0 0 2px rgba(76, 175, 80, 0.15);\n}\n\n.formGroup input:disabled,\n.formGroup select:disabled {\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n}\n\n.twoColumnGrid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 15px;\n  width: 100%;\n}\n\n/* ✅ Modal Actions - Fixed at bottom */\n.modalActions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 20px;\n  padding-top: 15px;\n  border-top: 1px solid #eee;\n  flex-shrink: 0; /* ✅ Prevent actions from shrinking */\n  background: white; /* ✅ Keep background white */\n  position: sticky;\n  bottom: 0;\n  z-index: 10;\n}\n\n.saveBtn {\n  background: #4caf50;\n  color: white;\n  padding: 10px 20px;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: background 0.3s ease;\n  white-space: nowrap; /* ✅ Prevent button text from wrapping */\n}\n\n.saveBtn:hover {\n  background: #3d9b41;\n}\n\n.saveBtn:active {\n  transform: scale(0.98);\n}\n\n.cancelBtn {\n  background: #6c757d;\n  color: white;\n  padding: 10px 20px;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: background 0.3s ease;\n  white-space: nowrap; /* ✅ Prevent button text from wrapping */\n}\n\n.cancelBtn:hover {\n  background: #5a6268;\n}\n\n.cancelBtn:active {\n  transform: scale(0.98);\n}\n\n.error {\n  color: #dc3545;\n  font-size: 12px;\n  margin-top: 4px;\n}\n\n/* ✅ Responsive for very small screens */\n@media screen and (max-width: 576px) {\n  .modalOverlay {\n    padding: 10px;\n    align-items: flex-start;\n    padding-top: 20px;\n  }\n\n  .modalBox {\n    padding: 20px;\n    width: 100%;\n    max-height: 95vh;\n    border-radius: 8px;\n  }\n\n  .modalBox h2 {\n    font-size: 18px;\n    margin-bottom: 15px;\n  }\n\n  .twoColumnGrid {\n    grid-template-columns: 1fr; /* ✅ Single column on small screens */\n    gap: 0;\n  }\n\n  .formGroup {\n    margin-bottom: 12px;\n  }\n\n  .formGroup input,\n  .formGroup select {\n    padding: 8px 10px;\n    font-size: 13px;\n  }\n\n  .modalActions {\n    flex-direction: column-reverse; /* ✅ Stack buttons vertically */\n    gap: 8px;\n    padding-top: 12px;\n    margin-top: 15px;\n  }\n\n  .modalActions button {\n    width: 100%; /* ✅ Full width buttons */\n    padding: 12px;\n    font-size: 14px;\n  }\n\n  .saveBtn,\n  .cancelBtn {\n    white-space: normal; /* ✅ Allow text wrap if needed */\n  }\n}\n\n/* ✅ Tablet screens */\n@media screen and (min-width: 577px) and (max-width: 768px) {\n  .modalBox {\n    width: 90%;\n    max-height: 85vh;\n    padding: 25px;\n  }\n\n  .twoColumnGrid {\n    gap: 12px;\n  }\n}\n\n/* ✅ Landscape mode on mobile */\n@media screen and (max-height: 600px) and (orientation: landscape) {\n  .modalOverlay {\n    align-items: flex-start;\n    padding-top: 10px;\n  }\n\n  .modalBox {\n    max-height: 95vh;\n    padding: 15px 20px;\n  }\n\n  .modalBox h2 {\n    font-size: 16px;\n    margin-bottom: 10px;\n  }\n\n  .formGroup {\n    margin-bottom: 8px;\n  }\n\n  .formGroup input,\n  .formGroup select {\n    padding: 6px 10px;\n    font-size: 13px;\n  }\n\n  .twoColumnGrid {\n    gap: 10px;\n  }\n\n  .modalActions {\n    margin-top: 10px;\n    padding-top: 10px;\n  }\n\n  .modalActions button {\n    padding: 8px 16px;\n    font-size: 13px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalOverlay": `Employeemodal_modalOverlay__rgdrd`,
	"modalBox": `Employeemodal_modalBox__PweZH`,
	"formGroup": `Employeemodal_formGroup__D9q1H`,
	"twoColumnGrid": `Employeemodal_twoColumnGrid__C8Awu`,
	"modalActions": `Employeemodal_modalActions__hxmMp`,
	"saveBtn": `Employeemodal_saveBtn__GkMbF`,
	"cancelBtn": `Employeemodal_cancelBtn__kYn5H`,
	"error": `Employeemodal_error__6nSxo`
};
export default ___CSS_LOADER_EXPORT___;
